import React from 'react'
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, CircularProgress, Typography, Divider, List, ListItem, ListItemButton, ListItemAvatar, Avatar, ListItemText } from '@mui/material';


const UserList = ({
    deptId,
    employees,
    loading,
}) => {
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1 }}>
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Box >
            {employees === null || employees?.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1 }}>
                    <Typography variant="subtitle2" component="div">데이터가 없습니다.</Typography>
                </Box>
            ) : (
                <Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', p: 1 }}>
                        <Typography variant="subtitle2" component="div">총:{employees.length} 명</Typography>
                    </Box>
                    <Divider />
                    <List sx={{ width: '100%', height: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                        {employees && employees.map((employee, index) => (
                            <ListItem key={index} dense divider={index === employee.length - 1 ? false : true} >
                                <ListItemButton
                                    component={RouterLink}
                                    to={`/goalsetting/${deptId}/${employee.usrUuid}`}
                                    end
                                    style={({ isActive }) => ({ background: isActive ? '#1769aa' : '', color: isActive ? '#fff' : '' })}

                                >
                                    <ListItemAvatar>
                                        {employee.profileImg ? (<Avatar alt={employee.usrNm} src={employee.profileImg} />) : (<Avatar>{employee?.usrNm.substring(0, 1)}</Avatar>)}
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={<Typography variant="body2" component="div">{employee.usrNm} {employee.gradeNm} ({employee.dptNm})</Typography>}
                                        secondary={<Typography variant="body2" component="div">{employee.emlAddr}</Typography>}
                                    />
                                </ListItemButton>
                            </ListItem>

                        ))}
                    </List>
                </Box>
            )}
        </Box>
    )
}

export default UserList